"use strict";
'use es6'; // eslint-disable-next-line no-unused-vars

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DOMElement;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function DOMElement(props, propName, componentName, location) {
  var value = props[propName];

  if (!(value && value.nodeType === 1)) {
    return new Error("Invalid prop `" + propName + "` supplied to " + componentName + ", expected " + ("a DOM Element, received `" + (0, _typeof2.default)(value) + "`"));
  }

  return null;
}

module.exports = exports.default;